import { render, staticRenderFns } from "./WMS.vue?vue&type=template&id=00ca9584&scoped=true&"
import script from "./WMS.vue?vue&type=script&lang=js&"
export * from "./WMS.vue?vue&type=script&lang=js&"
import style0 from "./WMS.vue?vue&type=style&index=0&id=00ca9584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ca9584",
  null
  
)

export default component.exports